import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { CommonModule, isPlatformBrowser, DOCUMENT } from '@angular/common';
import {
  RouterOutlet,
  RouterLink,
  RouterLinkActive,
  Router,
  NavigationEnd,
} from '@angular/router';

import { LoadingMaskComponent } from '../../components/loading-mask/loading-mask.component';
import { EmailQuoteComponent } from '../../components/email-quote/email-quote.component';

import { GlobalService } from '../../services/global.service';
import { SegmentService } from '../../services/segment.service';
import { filter } from 'rxjs/operators';
import { ToastModule } from 'primeng/toast';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    LoadingMaskComponent,
    EmailQuoteComponent,
    ToastModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  serverSideHomePageMask = false;
  showLoadingMask$ = this.globalService.showLoadingMask$;
  showPaymentGatewayAlert: boolean = false;
  maintenanceRoutes = [
    '/',
    '/quotes-steps-one',
    '/product',
    '/quotes-steps-two',
    '/quotes-steps-three',
    '/quotes-steps-four',
    '/payment-confirmation',
  ];
  constructor(
    public globalService: GlobalService,
    private segmentService: SegmentService,
    private router: Router,
    private renderer: Renderer2,
    private meta: Meta,
    @Inject(DOCUMENT) private doc: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}
  closePaymentGatewayAlert() {
    this.showPaymentGatewayAlert = false;
  }
  ngOnInit() {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (isPlatformBrowser(this.platformId)) {
          this.updateBodyClass(event.urlAfterRedirects);
          // const pathname = event.urlAfterRedirects.split('?')[0];
          // this.showPaymentGatewayAlert = this.maintenanceRoutes.includes(
          //   pathname,
          // );
          const purePath = event.urlAfterRedirects.split('?')[0];
          if (purePath !== '/quotes-steps-one') {
            this.segmentService.pageLoad();
          }
        } else {
          if (this.router.url === '/') {
            this.serverSideHomePageMask = true;
          }
          this.setCanonicalURL('https://www.world2cover.com.au');
        }
      });
  }
  updateBodyClass(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      console.log('url change subscribe', url);
      const body = document.body;
      body.classList.remove('modal-open');
      body.removeAttribute('style');
      body.removeAttribute('data-bs-overflow');
      body.removeAttribute('data-bs-padding-right');
      const modalBackdrops = document.querySelectorAll(
        '.modal-backdrop.fade.show',
      );
      modalBackdrops.forEach((modalBackdrop) => modalBackdrop.remove());
    }
  }

  setCanonicalURL(baseUrl: string) {
    let link: HTMLLinkElement | null = this.doc.querySelector(
      "link[rel='canonical']",
    );
    const url = baseUrl + this.router.url;

    if (link) {
      this.renderer.setAttribute(link, 'href', url);
    } else {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(this.doc.head, link);
    }
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({
      property: 'og:image',
      content: `https://www.world2cover.com.au/assets/images/w2c/w2clogo.png?20260416`,
    });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
  }
}
